var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"list-mode":"","title":_vm.Info.Section.PackagingList.Title}},[_c('kst-output',{attrs:{"field":"DefaultPackagingID","data":_vm.details,"catalog":_vm.Catalog}}),_c('List',{attrs:{"dataList":_vm.details.PackagingList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }